import { render, staticRenderFns } from "./LocalityGradeChart.vue?vue&type=template&id=abf1ef4a&scoped=true"
import script from "./LocalityGradeChart.vue?vue&type=script&lang=js"
export * from "./LocalityGradeChart.vue?vue&type=script&lang=js"
import style0 from "./LocalityGradeChart.vue?vue&type=style&index=0&id=abf1ef4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf1ef4a",
  null
  
)

export default component.exports